import { createRoutine } from 'redux-saga-routines';
import extendRoutine from 'utils/routines';

import {
  GET_APPLICATIONS,
  CREATE_APPLICATION,
  UPDATE_APPLICATION,
  DELETE_APPLICATION,
  GET_USERS_BY_ROLE,
  GET_APPLICATION_ROLES,
  GET_APPLICATION_PERMISSIONS,
  SELECTED_APPLICATION,
} from './constants';

// v2 actions
export const getApplications = createRoutine(GET_APPLICATIONS);
export const createApplication = extendRoutine(createRoutine(CREATE_APPLICATION), 'RESET');
export const updateApplication = extendRoutine(createRoutine(UPDATE_APPLICATION), 'RESET');
export const deleteApplication = extendRoutine(createRoutine(DELETE_APPLICATION), 'RESET');
export const getUsersByRole = extendRoutine(createRoutine(GET_USERS_BY_ROLE), 'RESET');
export const getApplicationRoles = extendRoutine(createRoutine(GET_APPLICATION_ROLES), 'RESET');
export const getApplicationPermissions = extendRoutine(createRoutine(GET_APPLICATION_PERMISSIONS), 'RESET');

// UI action
export const selectedApplication = extendRoutine(createRoutine(SELECTED_APPLICATION), 'RESET');
